import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SalesSharedPageRoutingModule } from './sales-shared-routing.module';

import { SalesSharedPage } from './sales-shared.page';

import { SharedModule } from '../../shared.module';
import { SalonMonsterDatePickerModule } from '../../components/smr-date-picker/smr-date-picker.module';
import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';
import { StylistPickerModule } from '../../components/stylist-picker/stylist-picker.module';

import { SaleTotalSummaryComponentModule } from './components/sale-total-summary/sale-total-summary.module';
import { TipsPaymentsManagerComponentModule } from './components/tips-payments-manager/tips-payments-manager.module';
import { SaleClientComponentModule } from './components/sale-client/sale-client.module';
import { SaleTotalSummaryComponent } from './components/sale-total-summary/sale-total-summary.component';
import { TipsPaymentsManagerComponent } from './components/tips-payments-manager/tips-payments-manager.component';
import { SaleClientComponent } from './components/sale-client/sale-client.component';
import { SaleCheckoutButtonsComponent } from './components/sale-checkout-buttons/sale-checkout-buttons.component';
import { SaleCheckoutButtonsComponentModule } from './components/sale-checkout-buttons/sale-checkout-buttons.module';
@NgModule({
  declarations: [
    SalesSharedPage,
    // SaleClientComponent,
   // SaleTotalSummaryComponent,
   // TipsPaymentsManagerComponent,
    // SaleCheckoutButtonsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SalesSharedPageRoutingModule,
    SharedModule,
    SalonMonsterDatePickerModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    StylistPickerModule,
    SaleClientComponentModule,
    SaleTotalSummaryComponentModule,
    TipsPaymentsManagerComponentModule,
    SaleCheckoutButtonsComponentModule
  ],
  exports:[   
    SaleClientComponent,
    SaleCheckoutButtonsComponent,
    SaleTotalSummaryComponent,
    TipsPaymentsManagerComponent,
    SaleCheckoutButtonsComponent
  ]
})
export class SalesSharedPageModule {}
